/* eslint-disable */
export default {
  title: 'Geschiedenis',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
